export default {
    research: {
        __typename: 'ResearchState',
        collapses: {
            __typename: 'ResearchCollapsesState',
            isCollapse1Collapsed: false,
            isCollapse2Collapsed: true,
            isCollapse3Collapsed: true,
            isCollapse4Collapsed: true
        },
        selectedTheme: {
            __typename: 'Theme',
            id: 0,
            name: ''
        },
        lastTerritoriesAggregated: false,
        selectedCategories: [0],
        selectedFilter: null,
        selectedProducts: [0],
        selectedMeasurementUnit: null,
        selectedMainGroup: null,
        selectedSubGroup: null,
        selectedPeriod: {
            __typename: 'ResearchSelectedPeriodState',
            start: 1990,
            end: 2010
        },
        selectedTerritories: [],
        selectedTerritoryTypeOnModalSelect: null,
        selectedTerritoryOnModalSelect: null,
        selectedTerritoryType: 'regions',
        territoryFilters: {
            __typename: 'ResearchTerritoryFiltersState',
            biomes: [],
            regions: [],
            states: [],
            mesoregions: [],
            microregions: [],
            cities: []
        },
        selectedLtYear: 0,
        landTenureFilters: {
            __typename: 'ResearchLandTenureFilters',
            categories: [],
            subcategories: [],
            themes: [],
            subthemes: [],
            sizes: [],
            measurement: 0
        },
        landTenureRange: {
            __typename: 'ResearchLandTenureRange',
            start: 0,
            end: 0,
            items: []
        },
        landTenureYear: 0,
        graphLockState: {
            __typename: 'ResearchGraphLockState',
            locked: false
        }
    }
};


// WEBPACK FOOTER //
// ./src/services/ApolloClient/defaultState.js